export default "__VITE_ASSET__CnokWWH0__"